import { Button, Col, Modal, Row } from 'antd'
import React from 'react'
import twoFactor from "../../../../static/image/two-factor.png";
import "../../login.scss";

type TModalForgotPassword = {
    visible: boolean,
    hideModal: any,
}

const ModalForgotPassword = (props: TModalForgotPassword) => {
    return (
        <Modal
            centered
            className='ant-modal-custom'
            visible={props.visible}
            closable={false}
            footer={null}
            destroyOnClose
            style={{ maxWidth: 450 }}
        >
            <Row type="flex" align='middle' gutter={[20, 20]} style={{ flexDirection: 'column' }}>
                <Col xs={24} style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <div style={{ marginBottom: 15 }}>
                        <img alt='logo-two-factor' src={twoFactor} />
                    </div>
                    <p style={{ marginBottom: 0, color: 'black', fontSize: 16 }}>
                        For password reset assistance,
                    </p>
                    <p style={{ color: 'black', fontSize: 16 }}>
                        please contact your organization’s administrator.
                    </p>
                </Col>
                <Col style={{ width: '100%', display: 'flex' }}>
                    <Button type='primary' style={{ flex: 1 }} onClick={props.hideModal}>
                        Close
                    </Button>
                </Col>
            </Row>
        </Modal>
    )
}

export default ModalForgotPassword